module.exports = __webpack_public_path__ + "static/media/n05.97e47ffc.jpg";